import axios from "axios";
import {
  DelegationCreateDto,
  DeleteRequestAccessDto,
  RequestAccessDto,
  RequestCreateDto,
  RequestDto,
  RequestedTaskDto,
} from "./delegation.types";
import { CreateTaskAccessForRequestDto, TaskDto } from "../types";

const API_URL = `${import.meta.env.VITE_API_BASE_URL}delegation`; // `${import.meta.env.VITE_API_BASE_URL}auth`;

const createRequest = async (
  createRequestData: RequestCreateDto,
): Promise<RequestDto> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.post(
    `${API_URL}/request/${createRequestData.noteId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error("Creating failed, no data received.");
};

const createRequestAccess = async (
  createRequestAccessData: DelegationCreateDto,
): Promise<RequestAccessDto> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.post(
    `${API_URL}/requestAccess/${createRequestAccessData.noteId}`,
    createRequestAccessData,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    },
  );

  if (response.data) return response.data;
  throw new Error("Creating failed, no data received.");
};

const deleteRequestAccess = async (
  deleteRequestAccessData: DeleteRequestAccessDto,
): Promise<void> => {
  const authToken = localStorage.getItem("daex-auth-token");

  await axios.delete(
    `${API_URL}/requestAccess/${deleteRequestAccessData.noteId}/${deleteRequestAccessData.requestAccessId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    },
  );
};

const deleteRequest = async (noteId: string): Promise<void> => {
  const authToken = localStorage.getItem("daex-auth-token");

  await axios.delete(`${API_URL}/request/${noteId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

const getRequests = async (): Promise<RequestAccessDto[]> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.get(`${API_URL}/requests`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });

  console.log(response.data);

  return response.data;
};

const acceptRequest = async (
  requestId: string,
  createTaskAccess?: CreateTaskAccessForRequestDto,
): Promise<TaskDto> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.post(
    `${API_URL}/acceptRequest/${requestId}`,
    createTaskAccess,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    },
  );
  return response.data;
};

const rejectRequest = async (requestId: string): Promise<string> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.post(
    `${API_URL}/rejectRequest/${requestId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    },
  );

  return response.data;
};

const getRequestedTask = async (
  requestId: string,
): Promise<RequestedTaskDto> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.get(`${API_URL}/request/${requestId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return response.data;
};

const delegationService = {
  createRequest,
  createRequestAccess,
  deleteRequestAccess,
  getRequestedTask,
  deleteRequest,
  getRequests,
  rejectRequest,
  acceptRequest,
};
export default delegationService;
